import React, { FunctionComponent, SVGProps } from 'react';

import { motion } from 'framer-motion';
import styled from 'styled-components';

export interface SquareProcessingIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const SquareProcessingIcon: FunctionComponent<
  SquareProcessingIconProps
> = ({ className, ...props }) => {
  const Bounce1 = {
    animate: { y: ['0%', '-6%', '-9%', '-3%', '0%'] },
  };

  const Bounce2 = {
    animate: {
      y: ['0%', '0%', '-6%', '-9%', '-3%'],
    },
  };

  const Bounce3 = {
    animate: {
      y: ['-3%', '0%', '0%', '-6%', '-9%'],
    },
  };

  const transitionValues = {
    duration: 0.8,
    repeat: Infinity,
    repeatType: 'yoyo',
    ease: 'easeOut',
  };

  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      className={className || ''}
      {...props}
    >
      <Background width="28" height="28" rx="4" ry="4" />
      <Circle
        cx="9"
        cy="16"
        r="2"
        variants={Bounce1}
        animate="animate"
        transition={{ y: transitionValues }}
      />
      <Circle
        cx="14"
        cy="16"
        r="2"
        variants={Bounce2}
        animate="animate"
        transition={{ y: transitionValues }}
      />
      <Circle
        cx="19"
        cy="16"
        r="2"
        variants={Bounce3}
        animate="animate"
        transition={{ y: transitionValues }}
      />
    </svg>
  );
};

export default SquareProcessingIcon;

const Background = styled.rect`
  fill: ${({ theme }) => theme.colors.iconBackground};
`;

const Circle = styled(motion.circle)`
  fill: ${({ theme }) => theme.colors.upload};
`;
